/**
 * File marquee-scroll.js.
 * Handles logic for the Marquee Scroll module.
 */

const marqueeTickers = () => {
  const marqueeTickers = document.querySelectorAll('.marquee-scroll__ticker');

  // Set width for each ticker and add a class if a clickable cta is present
  marqueeTickers.forEach(marqueeTicker => {
    const marqueeWrapperWidth = marqueeTicker.querySelector('.marquee-scroll__ticker-wrapper').offsetWidth;
    const marqueeCtaLinks = marqueeTicker.querySelectorAll('.marquee-scroll__ticker-cta--link').length;

    if (marqueeCtaLinks) marqueeTicker.classList.add('marquee-scroll__ticker--link');
    marqueeTicker.style.width = marqueeWrapperWidth + 'px';
  });
}

// Add to variant callback list
if (window.explat) {
  registerExperimentCallback((key, variant) => {
    marqueeTickers();
  });
}

// Init
marqueeTickers();
